<div class="w-full max-w-[800px] px-4 sm:px-8 md:px-16 py-6 sm:py-10 rounded-3xl uploader-status flex flex-col items-center justify-center align-middle">

  <h2 class="text-xl sm:text-2xl font-bold self-start">Asignar transacciones</h2>

  <h3 *ngIf="type===''" class="text-base sm:text-lg font-bold my-4 self-start">Transacciones seleccionadas:</h3>

  <!-- Cards de transacciones -->
  <div class="w-full" *ngIf="dataSource && type===''">
    <div *ngFor="let row of dataSource.data; let i = index"
      class="border border-gray-200 rounded-lg overflow-hidden mb-3 bg-white shadow-sm">

      <div class="flex justify-between items-center px-4 py-2 bg-gray-50 border-b border-gray-100">
        <div class="flex items-center gap-2 flex-wrap">
          <span class="text-xs font-semibold bg-green-100 text-green-800 px-2 py-0.5 rounded-full">#{{ row.id }}</span>
          <span class="text-xs font-medium text-gray-600">{{ row.paisOrigen }} → {{ row.paisDestino }}</span>
        </div>
        <button [disabled]="dataSource.data.length === 1" (click)="remover(i)" title="Remover"
          style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer;">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">remove_circle</mat-icon>
        </button>
      </div>

      <div class="px-4 py-3">
        <div class="grid grid-cols-2 gap-x-8 gap-y-2">
          <div>
            <span class="text-xs text-gray-500 block">Usuario</span>
            <span class="text-sm font-medium text-gray-900">{{ row.usuario?.nombre || '' }} {{ row.usuario?.apellidos || '' }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Beneficiario</span>
            <span class="text-sm font-medium text-gray-900">{{ row.cuentaBeneficiario?.nombre || '' }} {{ row.cuentaBeneficiario?.apellidos || '' }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Monto origen</span>
            <span class="text-sm font-bold text-green-700">{{ row.totalMonedaOrigen | currency:'$' }}</span>
          </div>
          <div>
            <span class="text-xs text-gray-500 block">Monto destino</span>
            <span class="text-sm font-bold text-green-700">{{ row.totalMonedaDestino | currency:'$' }}</span>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="mt-6 w-full">
    <label class="font-bold text-base sm:text-lg block mb-3">Cuenta de trabajo</label>
    <mat-form-field appearance="outline" class="w-full modern-field">
      <mat-label>Selecciona una cuenta</mat-label>
      <mat-select [(ngModel)]="selectedWorkingAccount" name="selectedWorkingAccount">
        <mat-option [value]="item" *ngFor="let item of workingAccountList">
          <span *ngIf="item.banco?.nombre === 'BINANCE'">{{item.banco?.nombre}} - {{item.nombre | uppercase}} {{item.apellidos | uppercase}}</span>
          <span *ngIf="item.banco?.nombre !== 'BINANCE'">{{item.banco?.nombre}} {{item.tipoCuenta?.nombre}}: {{item.numeroCuenta}} - {{item.nombre | uppercase}} {{item.apellidos | uppercase}}</span>
        </mat-option>
      </mat-select>
      <mat-icon matPrefix style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
    </mat-form-field>
  </div>

  <div class="flex flex-col sm:flex-row justify-center gap-3 sm:gap-10 w-full mt-6 sm:mt-10">
    <button type="button"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
      [style.background-color]="selectedWorkingAccount ? '#1C593D' : '#d1d5db'"
      [style.color]="selectedWorkingAccount ? 'white' : '#9ca3af'"
      [style.cursor]="selectedWorkingAccount ? 'pointer' : 'not-allowed'"
      (click)="assignTransaction()" [disabled]="!selectedWorkingAccount"
      onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
      Asignar transacciones
    </button>
    <button type="button" (click)="onNoClick()"
      class="w-full sm:w-1/2 text-center"
      style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
      onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
      Cancelar
    </button>
  </div>

</div>
